import { render, staticRenderFns } from "./NavigationComponent.vue?vue&type=template&id=91095cd2"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"
import style0 from "./NavigationComponent.vue?vue&type=style&index=0&id=91095cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports